<template>
  <div class="flex flex-col flex-wrap w-full">
    <div class="vx-row mt-4">
      <div class="vx-col w-full">
        <h1> General </h1>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Clientes totales por plan">
          <div id="vx-col w-full lg:w-1/3 mb-base">
            <vue-apex-charts type="pie" height="500" class="my-12" :options="pieChartOptions" :series="pieChart" v-if="this.pieChartOptions.labels.length > 0"/>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-2/3 lg:w-2/3">
        <vx-card title="Histórico de Nuevos Clientes">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts type="line" height="266" :options="lineChartOptions" :series="lineChart" />
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { authComputed } from '../../store/helpers.js'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'

import MyClients from '@/components/widgets/MyClients.vue'

export default {
  name: 'dashboard',
  components: {
    MyClients,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown
  },
  data () {
    return {
      
      pieChart: [],
      pieChartOptions: {
        labels: [],
        dataLabels: {
          enabled: true,
          formatter (val, opts) {
            return `${opts.w.config.series[opts.seriesIndex]  }`
          }
        },
        legend: { 
          show: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '14px',
          onItemClick: {
            toggleDataSeries: true
          },
          onItemHover: {
            highlightDataSeries: true
          }
        },
        chart: {
          type: 'pie',
          offsetY: 0,
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: 5
        },
        colors: ['#7961F9', '#FF9F43', '#EA5455'],
        fill: {
          type: 'gradient',
          gradient: {
            gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
          }
        }
      },


      lineChart: [
        {
          name: 'clientes',
          data: []
        }
      ],
      lineChartOptions: {
        dataLabels: { enabled: true },
        chart: {
          toolbar: { show: false },
          dropShadow: { enabled: false, top: 20, left: 2, blur: 6, opacity: 0.20 }
        },
        stroke: { curve: 'smooth', width: 4 },
        grid: { borderColor: '#ebebeb' },
        legend: { show: false },
        colors: ['#df87f2'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            inverseColors: false,
            gradientToColors: ['#7367F0'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        },
        markers: {
          size: 0,
          hover: { size: 5 }
        },
        xaxis: {
          axisBorder: { show: false },
          labels: { style: { cssClass: 'text-grey fill-current' } },
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        yaxis: {
          tickAmount: 5,
          labels: {
            style: { cssClass: 'text-grey fill-current' },
            formatter (val) {
              return val > 999 ? `${(val / 1000).toFixed(1)  }k` : val
            }
          }
        }
      }
    }
  },
  computed: {
    ...authComputed,
    state () {
      return this.$store.state.user
    }
  }, 
  created () {
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    if (userRoles && userRoles.some(item => item.id_role > 50)) {
      this.$router.push({ name: 'dashboard-clientes' }) 
    }

    this.$store.dispatch('fetchTotalClientsByPlan')
      .then((res) => {
        const VP_Plans = ['Plan Free Trial', 'Plan Anual', 'Plan Mensual']
        const results = res.data.statistics
          .sort((a, b) => a.id_service - b.id_service)
          .filter(item => !VP_Plans.includes(item.name_service))
        this.totalClientsByPlan = results
        this.pieChartOptions.labels = results.map(item => item.name_service)
        this.pieChart = results.map(item => item.total_active_clients)
      })


    this.$store.dispatch('fetchInmigrationClients')
      .then((res) => {
        const results = res.data.addedServices.sort((a, b) => a.id_service - b.id_service)

        // Determine the range of years
        const years = results.map(item => new Date(item.created_at_added_service).getFullYear())
        const minYear = Math.min(...years)
        const maxYear = Math.max(...years)

        // Initialize monthYearCount with all months for each year in the range, months 1-12
        const monthYearCount = {}
        for (let year = minYear; year <= maxYear; year++) {
          for (let month = 1; month <= 12; month++) { // Adjust for 1-12 month range
            const key = `${year}-${month - 1}` // Keeping key as year-month (0-11) for compatibility
            monthYearCount[key] = { month, year, count: 0 }
          }
        }       

        // Adjusting for the current month and year
        const now = new Date()
        const currentYear = now.getFullYear()
        const currentMonth = now.getMonth() + 1 // Adjust for 1-12 month range
        // Ensure we're not populating months beyond the current month and year
        for (let year = minYear; year <= currentYear; year++) {
          const lastMonth = year === currentYear ? currentMonth : 12
          for (let month = 1; month <= lastMonth; month++) {
            const key = `${year}-${month - 1}` // Keeping key as year-month (0-11) for compatibility
            if (!monthYearCount[key]) {
              monthYearCount[key] = { month, year, count: 0 }
            }
          }
        }       

        // Populate monthYearCount with actual data
        results.forEach((item) => {
          const date = new Date(item.created_at_added_service)
          const year = date.getFullYear()
          const month = date.getMonth() + 1 // Adjust for 1-12 month range
          const key = `${year}-${month - 1}` // Keeping key as year-month (0-11) for compatibility
          monthYearCount[key].count++
        })

        const uniqueMonthYearCount = Object.values(monthYearCount).filter(({ year, month }) => year < currentYear || (year === currentYear && month <= currentMonth))

        const uniqueMonthYearCountLast24 = uniqueMonthYearCount.slice(-24)
        
        this.lineChart = [{name: 'Clientes', data: uniqueMonthYearCountLast24.map(item => item.count)}]
        const lineChartOptions = Object.assign({}, this.lineChartOptions)

        const umyc = uniqueMonthYearCountLast24.map(item => `${item.year}-${item.month}`)
        this.lineChartOptions.label = umyc
        this.lineChartOptions.xaxis.categories = umyc
        this.lineChartOptions = Object.assign({}, lineChartOptions)
      })
  }
}
</script>